import { useTranslation } from 'react-i18next';
import type { StoryOptions } from '../../lib/stories';
import { RadioGroup } from './RadioGroup';

type LayersStepProps = {
  options: StoryOptions;
  artStyle: string;
  ageGroup: string;
  mood: string;
  genre: string;
  onChange: (field: 'artStyle' | 'ageGroup' | 'mood' | 'genre', value: string) => void;
  onSubmit: () => void;
  onBack: () => void;
  submitting: boolean;
  error: string | null;
};

export function LayersStep({
  options,
  artStyle,
  ageGroup,
  mood,
  genre,
  onChange,
  onSubmit,
  onBack,
  submitting,
  error,
}: LayersStepProps) {
  const { t } = useTranslation();
  const translateOptions = (opts: typeof options.art_styles, ns: string) =>
    opts.map((opt) => ({ value: opt.value, label: t(`wizard.${ns}.${opt.value}`, opt.label) }));
  return (
    <div className="wizard-step" data-step="layers">
      <h2 className="wizard-step__title">{t('wizard.layersTitle')}</h2>
      <p className="wizard-step__hint">{t('wizard.layersHint')}</p>

      <RadioGroup
        label={t('wizard.artStyle')}
        name="art-style"
        value={artStyle}
        options={translateOptions(options.art_styles, 'artStyles')}
        onChange={(v) => onChange('artStyle', v)}
      />
      <RadioGroup
        label={t('wizard.age')}
        name="age-group"
        value={ageGroup}
        options={translateOptions(options.age_groups, 'ageGroups')}
        onChange={(v) => onChange('ageGroup', v)}
      />
      <RadioGroup
        label={t('wizard.genre')}
        name="genre"
        value={genre}
        options={translateOptions(options.genres, 'genres')}
        onChange={(v) => onChange('genre', v)}
      />
      <RadioGroup
        label={t('wizard.mood')}
        name="mood"
        value={mood}
        options={translateOptions(options.moods, 'moods')}
        onChange={(v) => onChange('mood', v)}
      />

      {error && <p className="form-error">{error}</p>}

      <div className="wizard-footer">
        <button type="button" className="btn btn--ghost" onClick={onBack} disabled={submitting}>
          {t('common.back')}
        </button>
        <button
          type="button"
          className="btn btn--primary"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? t('wizard.generating') : t('wizard.generate')}
        </button>
      </div>
    </div>
  );
}
